import "./PreventiveMaintenanceAndRepairs.module.css";
import Header from "@/reusable_sections/Header";
import MaintenanceHero from "./sections/MaintenanceHero";
import Maintenance from "./sections/Maintenance";
import MaintenanceCTA from "./sections/MaintenanceCTA";
import Footer from "@/reusable_sections/Footer";
export default function PreventiveMaintenanceAndRepairsPage() {
  return <div>
      <Header />
      <MaintenanceHero />
      <Maintenance />
      <MaintenanceCTA />
      <Footer />
    </div>;
}